/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import internalReset from '@/useCases/errors/internalReset'
import isReleaseError from '@/useCases/errors/isReleaseError'
import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error)
  }, [error])

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)

    // Check if it's a chunk load error or stream-related error
    if (isReleaseError(error)) {
      console.log('🚀 ~ error ~ reload')
      internalReset(reset)
    }
  }, [error])

  return (
    <div>
      <h2>Something went wrong!!</h2>
      <h3>{error.message}</h3>
      <button onClick={() => internalReset(reset)}>Try again.</button>
    </div>
  )
}
